// The DB stores UTC (timestamptz); every display uses Asia/Tokyo.
export const TIME_ZONE = "Asia/Tokyo";

const dateFmt = new Intl.DateTimeFormat("ja-JP", { timeZone: TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" });
const dateTimeFmt = new Intl.DateTimeFormat("ja-JP", {
  timeZone: TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

const toDate = (v: string | Date) => (typeof v === "string" ? new Date(v) : v);

export const formatDate = (v: string | Date | null | undefined) => (v ? dateFmt.format(toDate(v)) : "—");
export const formatDateTime = (v: string | Date | null | undefined) => (v ? dateTimeFmt.format(toDate(v)) : "—");

/** Gregorian year → 和暦 (Reiwa era began 2019). */
export function toWareki(year: number): string {
  if (year >= 2019) return year === 2019 ? "令和元年" : `令和${year - 2018}年`;
  if (year >= 1989) return year === 1989 ? "平成元年" : `平成${year - 1988}年`;
  return `${year}年`;
}

/** e.g. 2026 → "2026年度（令和8年度）" — the form tax articles must use (brief §12). */
export function fiscalYearLabel(year: number): string {
  return `${year}年度（${toWareki(year).replace(/年$/, "年度")}）`;
}

/** Japanese fiscal year (April–March) for a date in Asia/Tokyo. */
export function currentFiscalYear(now = new Date()): number {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: TIME_ZONE, year: "numeric", month: "numeric" }).formatToParts(now);
  const y = Number(parts.find((p) => p.type === "year")!.value);
  const m = Number(parts.find((p) => p.type === "month")!.value);
  return m >= 4 ? y : y - 1;
}

/** The calendar year of a date, in Asia/Tokyo. */
export function tokyoYear(now = new Date()): number {
  return Number(new Intl.DateTimeFormat("en-US", { timeZone: TIME_ZONE, year: "numeric" }).format(now));
}

/** "YYYY-MM" of a date, in Asia/Tokyo. */
export function tokyoMonth(now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: TIME_ZONE, year: "numeric", month: "2-digit" }).formatToParts(now);
  return `${parts.find((p) => p.type === "year")!.value}-${parts.find((p) => p.type === "month")!.value}`;
}

/** UTC instants bounding a calendar month in Asia/Tokyo (UTC+9, no DST): [start, end). */
export function tokyoMonthRange(ym: string): { start: Date; end: Date } {
  const [y, m] = ym.split("-").map(Number) as [number, number];
  return { start: new Date(Date.UTC(y, m - 1, 1, -9)), end: new Date(Date.UTC(y, m, 1, -9)) };
}

/** "YYYY-MM" `back` months before a month ("2026-11", 1 → "2026-10"; negative looks ahead). */
export function monthBefore(ym: string, back: number): string {
  const [y, m] = ym.split("-").map(Number) as [number, number];
  const d = new Date(Date.UTC(y, m - 1 - back, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}`;
}
